module.exports = __webpack_public_path__ + "img/sa_1.4e5a1625.png";